<template>
  <router-view />
</template>

<script>
// import * as _ from "lodash";

export default {
  name: "app",
};
</script>

<style>
@import "~bootstrap-vue/dist/bootstrap-vue.css";

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

body {
  padding: 0 !important;
  margin: 0 !important;
}

.filterbar {
  margin: 0px !important;
  padding: 0px !important;
  text-align: center;
}

.nopadding {
  padding: 0px !important;
  margin: 0px !important;
}
.text-center {
  text-align: center;
}
.sticky-header {
  position: sticky;
  top: 0;
  background: white;
  white-space: nowrap;
}
.sticky-filter {
  position: sticky;
  background: white;
}
@media screen and (max-width: 768px) {
  .hide-on-mobile {
    display: none !important;
  }
}
</style>
